{
  "Accessibility Menu": "รายการการช่วยการเข้าถึง",
  "Reset settings": "รีเซ็ตการตั้งค่า",
  "Close": "ปิด",
  "Content Adjustments": "การปรับเนื้อหา",
  "Adjust Font Size": "ปรับขนาดตัวอักษร",
  "Highlight Title": "เน้นหัวข้อ",
  "Highlight Links": "เน้นลิงก์",
  "Readable Font": "แบบอักษรที่อ่านง่าย",
  "Color Adjustments": "การปรับสี",
  "Dark Contrast": "ความคมชัดแบบมืด",
  "Light Contrast": "ความคมชัดแบบสว่าง",
  "High Contrast": "ความคมชัดสูง",
  "High Saturation": "ความอิ่มตัวของสีสูง",
  "Low Saturation": "ความอิ่มตัวของสีต่ำ",
  "Monochrome": "ขาวดำ",
  "Protanopia": "ตาบอดสีแดง",
  "Deuteranopia": "ตาบอดสีเขียว",
  "Tritanopia": "ตาบอดสีน้ำเงิน",
  "Visual & Navigation Aids": "เครื่องมือช่วยด้านการมองเห็นและการนำทาง",
  "Additional Tools": "เครื่องมือเพิ่มเติม",
  "Reading Guide": "เครื่องมือช่วยอ่าน",
  "Stop Animations": "หยุดการเคลื่อนไหว",
  "Big Cursor": "เคอร์เซอร์ขนาดใหญ่",
  "Screen Reader": "โปรแกรมอ่านหน้าจอ",
  "Hide Images": "ซ่อนรูปภาพ",
  "Image Tooltips": "คำอธิบายรูปภาพ",
  "Page Structure": "โครงสร้างหน้าเว็บ",
  "Super Focus": "โฟกัสพิเศษ",
  "Magnifier": "แว่นขยาย",
  "Increase Font Size": "เพิ่มขนาดตัวอักษร",
  "Decrease Font Size": "ลดขนาดตัวอักษร",
  "Letter Spacing": "ระยะห่างระหว่างตัวอักษร",
  "Line Height": "ระยะห่างระหว่างบรรทัด",
  "Font Weight": "ความหนาของตัวอักษร",
  "Dyslexia Font": "แบบอักษรสำหรับผู้มีปัญหาการอ่าน",
  "Language": "ภาษา",
  "Open Accessibility Menu": "เปิดรายการการช่วยการเข้าถึง",
  "Accessibility Profiles": "โปรไฟล์การเข้าถึง",
  "Seizure Safe Profile": "โปรไฟล์ปลอดภัยจากอาการชัก",
  "Stops animations and reduces color saturation.": "หยุดแอนิเมชันและลดความอิ่มตัวของสี",
  "Blind Profile": "โปรไฟล์สำหรับผู้พิการทางสายตา",
  "Activates the screen reader for auditory navigation.": "เปิดใช้โปรแกรมอ่านหน้าจอสำหรับการนำทางด้วยเสียง",
  "Visually Impaired Profile": "โปรไฟล์สำหรับผู้มีสายตาอ่อน",
  "Enhances contrast and readability for low vision.": "ปรับปรุงความคมชัดและการอ่านสำหรับผู้มีสายตาอ่อน",
  "ADHD Friendly Profile": "โปรไฟล์สำหรับผู้ที่มี ADHD",
  "Reduces distractions for better focus.": "ลดสิ่งรบกวนเพื่อให้มีสมาธิดีขึ้น",
  "Cognitive & Learning Profile": "โปรไฟล์การรู้คิดและการเรียนรู้",
  "Helpful tools for reading and comprehension.": "เครื่องมือที่เป็นประโยชน์สำหรับการอ่านและความเข้าใจ",
  "Motor Impaired Profile": "โปรไฟล์สำหรับผู้พิการทางการเคลื่อนไหว",
  "Optimizes the site for keyboard-only navigation.": "ปรับแต่งเว็บไซต์สำหรับการนำทางด้วยแป้นพิมพ์เท่านั้น",
  "Headings": "หัวข้อ",
  "Landmarks": "จุดสังเกต",
  "Links": "ลิงก์",
  "Focus element": "โฟกัสที่องค์ประกอบ",
  "Visit link": "เยี่ยมชมลิงก์"
}